export const currencyFormatter = (amount: number, currency: string) => {
  const formattedCurrency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency
  })
  return formattedCurrency.format(amount)
}
